<div class="alert d-flex align-items-center mb-0"
     [class]="severityClass()"
     role="alert">
  <i class="fa fa-light alert-icon"
     [class]="icon()" 
     aria-hidden="true"
  ></i>
  <div>
    <strong class="fw-medium">{{ summary() }}</strong>
    <p class="mb-0">
      @if (detail(); as detailValue) {
        {{ detailValue }}
      } @else {
        <ng-content></ng-content>
      }
    </p>
  </div>
</div>
